import { useSelector, shallowEqual } from 'react-redux';
import UtmTracking from 'types/UtmTracking';
import State from 'types/State';

export default function useUtmTracking(): UtmTracking {
  const tracking = useSelector<State, UtmTracking>((state) => state.utmTracking, shallowEqual);

  return tracking;
}
